var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view charge-search-tab" }, [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { "overflow-y": "auto" } },
      [
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid-wrapper", {
              attrs: {
                "config-module": "185013",
                "grid-options": _vm.gridOptions,
                "export-file-name": _vm.$t(_vm.filename),
                "column-defs": _vm.finalColumnDefs,
                "row-data": _vm.rowData,
                "per-config-name": _vm.perConfigName,
                "refresh-id": _vm.gridRefreshId,
                "show-row-groups": _vm.dataListDragGroup
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "pagination-wrapper amount-sum",
            staticStyle: {
              "flex-wrap": "unset",
              "align-items": "unset",
              padding: "2px 5px",
              "line-height": "28px"
            },
            attrs: { id: "footer-wrapper" }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row-reverse",
                  "min-width": "600px"
                }
              },
              [
                _c("charge-amount-sum-by-currency", {
                  key: "amountSumByCurrency",
                  attrs: {
                    "data-provider": _vm.dataProvider,
                    "cache-prefix": "BillTab"
                  },
                  on: { callback: _vm.onSumCallbak }
                }),
                _c("amount-sum-master-bold", {
                  key: "sumJobEquivalentRMB",
                  ref: "sumJobEquivalentRMB",
                  attrs: {
                    datafield: "CONVERT_TO_CNY_PROFIT",
                    title: _vm.$t("CargoMsg.Cargo_ConversionProfitCNYP"),
                    "data-provider": _vm.rowData
                  }
                }),
                _c("amount-sum-master-bold", {
                  key: "sumJobRmbEquivalentPayable",
                  ref: "sumJobRmbEquivalentPayable",
                  attrs: {
                    datafield: "CONVERT_TO_CNY_AP",
                    title: _vm.$t("CargoMsg.Cargo_ConversionAPCNY") + ":",
                    "data-provider": _vm.rowData
                  }
                }),
                _c("amount-sum-master-bold", {
                  key: "sumJobRmbEquivalentReceiveable",
                  ref: "sumJobRmbEquivalentReceiveable",
                  attrs: {
                    datafield: "CONVERT_TO_CNY_AR",
                    title: _vm.$t("CargoMsg.Cargo_ConversionARCNY") + ":",
                    "data-provider": _vm.rowData
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "flex-grow": "1",
                  display: "inline-flex",
                  "flex-wrap": "wrap"
                }
              },
              [
                !_vm.showSumPop
                  ? [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-flex",
                            "flex-wrap": "wrap"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "FinanceManage.CurrencyAccountsReceivable"
                                )
                              )
                            )
                          ]),
                          _vm._l(_vm.arCurrencySum, function(item, index) {
                            return _c("div", { key: index }, [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "8px" } },
                                [_vm._v(_vm._s(item.currency))]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "padding-right": "8px",
                                    color: "gray"
                                  }
                                },
                                [_vm._v(_vm._s(item.amount.toFixed(2)))]
                              )
                            ])
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-flex",
                            "flex-wrap": "wrap"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("FinanceManage.CurrencyAccountsPayable")
                              )
                            )
                          ]),
                          _vm._l(_vm.apCurrencySum, function(item, index) {
                            return _c("div", { key: index }, [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "8px" } },
                                [_vm._v(_vm._s(item.currency))]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "padding-right": "8px",
                                    color: "gray"
                                  }
                                },
                                [_vm._v(_vm._s(item.amount.toFixed(2)))]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _c(
              "div",
              { staticStyle: { display: "inline-flex", "min-width": "150px" } },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_AllAmountP") + _vm.rowData.length
                    )
                  )
                ]),
                _c("div", { staticStyle: { margin: "0px 10px" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_SelectedItems", [
                        "[" + _vm.numSelected + "]"
                      ])
                    )
                  )
                ])
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }